import React from 'react';

const Acp = () => (
  <div>
    <br /><br />
    <h2>Federal Internet Discount Program</h2>
      <p>A reliable connection is essential, and we're excited to support the FCC's <a href="https://www.fcc.gov/acp">Affordable
          Connectivity Program (ACP)</a>. Our mission is to end the digital divide, and we are proud to support this
          effort to make broadband more affordable and accessible for all.
      </p>

      <p>Through this program, qualifying customers will be eligible for a $30 per month discount on any internet
          service option with PD Fiber. Find out if you meet the program requirements below.
      </p>

      <h3>
          Program Requirements
      </h3>
      <p>
          To qualify for this discount program, your household must fulfill one of the below requirements:
      </p>
      <p>
      <ul>
          <li>
              Has an income that is at or below 200% of the
              <a href="https://aspe.hhs.gov/poverty-guidelines/" target="_blank"> Federal Poverty Guidelines</a>
          </li>
          <li>
              Participates in certain assistance programs, such as SNAP, Medicaid, Federal Public Housing Assistance,
              SSI, WIC, or <a href="https://www.fcc.gov/lifeline-consumers">Lifeline</a>
          </li>
          <li>
              Participates in Tribal specific programs, such as Bureau of Indian Affairs General Assistance,
              Tribal TANF, or Food Distribution Program on Indian Reservations
          </li>
          <li>
              Is Approved to receive benefits under the free and reduced-price school lunch program or the school
              breakfast program, including through the USDA Community Eligibility Provision in the 2019-2020,
              2020-2021, or 2021-2022 school year
          </li>
          <li>
              Received a Federal Pell Grant during the current award year
          </li>
      </ul>
      </p>
      <p>
          If you meet one of these requirements, please visit the <a href="https://ebb.pdfiber.com" target="_blank">
          PD Fiber ACP qualification and registration portal</a> to get qualified through USAC and the FCC 
          and to get entered into our system. If you have any questions, please give us a call at (573) 559-1615 
          option 2 to speak to a representative.
      </p>

      <p>
          <h6>
              *The Affordable Connectivity Program (ACP) is a government initiative that reduces the
              broadband internet access service bill for qualifying households. If they continue to
              receive service, households will be subject to PD Fiber’s undiscounted rates and general terms
              and conditions at the end of the program. Households may obtain broadband service supported
              by the ACP from any participating provider of their choosing. Households may transfer their
              ACP benefit to another provider at any time.
          </h6>
      </p>
  </div>
);

export default Acp;


// WEBPACK FOOTER //
// ./src/components/sections/programs/acp.js